import { RouteObject } from'react-router-dom';
import { CreateComplaint } from './components/create/CreateComplaint';

export const complaintRoutes: RouteObject[] = [
 {
 path:'create/complaint',
 element: <CreateComplaint />,
 }
];
